import { Button, Modal } from "flowbite-react";
import { HiExclamation } from "react-icons/hi";

// Integrations that also delete ingested customer data on disconnect, not just the
// credential. Slack purges the messages Pano has stored (data-handling commitment, §12 of
// the Slack-as-a-data-source plan). Saying "your settings are kept" without this would be
// true and still misleading — the thing a Slack customer would most want warned about is
// the only thing that is actually destroyed.
const PURGES_INGESTED_DATA = {
  Slack:
    "Messages Panora has already stored will be deleted and cannot be recovered.",
};

/**
 * Disconnect confirmation, shared by all five integration surfaces.
 *
 * The copy changed with PAN-258 because the BEHAVIOUR changed. It used to say "you may need
 * to reconfigure your settings", which was accurate when disconnect deleted the integration
 * row and cascaded through its config — that deletion destroyed a paying customer's field
 * mappings in June 2026 and eleven customization keys of our own on 2026-07-31. Disconnect
 * now keeps the configuration and removes only the credential, so the old warning would be a
 * false deterrent: it would talk customers out of a reconnect that costs them nothing.
 */
export const DisconnectConfirmation = ({
  show,
  onConfirm,
  onCancel,
  integrationName,
}) => {
  const purgeNotice = PURGES_INGESTED_DATA[integrationName];

  return (
    <Modal show={show} popup onClose={onCancel} size="md">
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <HiExclamation className="h-6 w-6 text-red-600" />
          </div>
          <h3 className="mb-3 text-lg font-semibold text-gray-900">
            Disconnect {integrationName}?
          </h3>
          <p className="mb-2 text-sm text-gray-500">
            Data will stop syncing and Panora's access to {integrationName} will
            be removed.
          </p>
          <p className="mb-5 text-sm text-gray-500">
            <span className="font-medium text-gray-700">
              Your settings are kept.
            </span>{" "}
            Reconnecting the same {integrationName} account restores them.
          </p>
          {purgeNotice && (
            <p className="mb-5 text-sm text-red-600">{purgeNotice}</p>
          )}
          <div className="flex justify-center gap-4">
            <Button color="gray" onClick={onCancel}>
              Cancel
            </Button>
            <Button color="failure" onClick={onConfirm}>
              Disconnect
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
